import {getPrefix} from './getPrefix.js';

export class VeedoPlayer {
    static init(script) {
        const p = getPrefix(script, '/js/veedoplayer.js');
        VeedoPlayer.Prefix=p.Prefix;
        VeedoPlayer.Origin=p.Origin;
    }    
}

if (document.readyState=='complete') {
    VeedoPlayer.init(document.currentScript);
} else {
    const cs = document.currentScript;
    document.addEventListener(`DOMContentLoaded`, function() {
        VeedoPlayer.init(cs);
    });
}
